var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"report__overview-detail-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"report__overview-detail-description"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }